import { Accessor, JSX } from 'solid-js';

type BaseMenuItem<T> = {
  id: string;
  label: string;
  tooltip?: string;
  disabled?: boolean;
  value: Accessor<T>;
  setValue(value: T): void;
};

export type ToggleMenuItem = BaseMenuItem<boolean> & {
  type: 'toggle';
  icon?: string | JSX.Element;
};

export type CheckboxMenuItem = BaseMenuItem<boolean> & {
  type: 'checkbox';
  icon?: string | JSX.Element;
  children?: ControlMenuItemType[];
  indeterminate?: Accessor<boolean>;
};

export type RadioOption = {
  id: string;
  label: string;
  icon?: string | JSX.Element;
  labelRight?: string;
  children?: ControlMenuItemType[];
};

export type RadioGroupMenuItem = Omit<BaseMenuItem<string>, 'label'> & {
  type: 'radiogroup';
  options: RadioOption[];
  isUnselectionAllowed?: boolean;
  emitWhenAlreadySelected?: boolean;
};

export type ActionMenuItem = {
  id: string;
  type: 'action';
  label: string;
  icon?: string | JSX.Element;
  disabled?: boolean;
  selected?: boolean;
  replayable?: boolean;
  children?: ControlMenuItemType[];
  onClick(): void;
};

export type DividerMenuItem = {
  id: string;
  type: 'divider';
};

export type HeaderMenuItem = {
  id: string;
  type: 'header';
  label: string;
};

export type ControlMenuItemType =
  | ToggleMenuItem
  | CheckboxMenuItem
  | RadioGroupMenuItem
  | ActionMenuItem
  | DividerMenuItem
  | HeaderMenuItem;

export type ControlMenuNestedSubmenuProps = {
  getChildrenItems: Accessor<ControlMenuItemType[]>;
  isMobile: boolean;
  openMenus: Set<string>;
  setOpenMenus(updater: (prev: Set<string>) => Set<string>): void;
  onNavigate(item: ControlMenuItemType): void;
  onClose?(): void;
  parentOpensUpward?: boolean;
};

export type ControlMenuNestedSubmenuSharedProps = Omit<
  ControlMenuNestedSubmenuProps,
  'getChildrenItems'
>;

export const DELETE_ALL_MENU_ITEM_ICON = 'tc-icon-delete-all';
